import { render } from "./VersionList.vue?vue&type=template&id=15445ba9&scoped=true&ts=true&lang=pug"
import script from "./VersionList.vue?vue&type=script&lang=ts"
export * from "./VersionList.vue?vue&type=script&lang=ts"

import "./VersionList.vue?vue&type=style&index=0&id=15445ba9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15445ba9"]])

export default __exports__